import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { IPricing } from '../../../../components/S/pricing/types';
import { getObjectByKey } from '../../../../components/S/pricing/utils';
import {
  PARTNER_META_KEY,
  PRICING_META_KEY,
} from '../../../../components/partner-pages/constants';
import PartnerPageDataService from '../../../../components/partner-pages/services/partner-pages.service';
import { FM_ACTIONS, returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';
import { handleTrack } from '../../../../utils/tracker';
import { PricingPage } from '../../../../components/S/pricing';

const Pricing: React.FC<IPricing> = (props) => {
  useEffect(() => {
    if (window.location.href.includes('/s/pricing')) {
      sessionStorage.setItem('/s/pricing', `mp_pricing_old`);
    }

    handleTrack({
      label: 'pricing-page-old',
      action: FM_ACTIONS.pageview,
    });
  }, []);

  return <PricingPage {...props} />;
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  async () => {
    try {
      const resMeta = await PartnerPageDataService.getMetaDataMulti(
        [PARTNER_META_KEY, PRICING_META_KEY].join(',')
      );
      let responseDataMeta;
      if (resMeta.data) {
        responseDataMeta = resMeta.data;
        return {
          props: {
            pricePageData: getObjectByKey(responseDataMeta, PRICING_META_KEY),
            metaData: getObjectByKey(responseDataMeta, PARTNER_META_KEY),
          },
        };
      }
    } catch (error) {
      return returnNoProps();
    }
    return returnNoProps();
  }
);

export default Pricing;
